import { Box, Typography, Stack } from '@mui/material';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import CouponUsedImg from '../../../assets/images/pages/my-coupon/coupon-used.webp';
import AppButton from '../../../components/ui/AppButton';
import { CouponStatus } from '../../../constants/coupon';

const couponStyles = {
  position: 'relative',
  '--r': '15px',
  borderRadius: '20px',
  overflow: 'hidden',
  boxShadow: '0 10px 20px rgba(0,0,0,0.12)',
  background: 'linear-gradient(to right, #fff, #cad4de, #fff, #cad4de, #fff)',
  mask: `radial-gradient(var(--r) at calc(var(--r) - 5px) 50%, transparent 98%, black) calc(-1 * var(--r)) 0, radial-gradient(var(--r) at calc(100% - var(--r) + 5px) 50%, transparent 98%, black) var(--r) 0`,
  WebkitMask: `radial-gradient(var(--r) at calc(var(--r) - 5px) 50%, transparent 98%, black) calc(-1 * var(--r)) 0, radial-gradient(var(--r) at calc(100% - var(--r) + 5px) 50%, transparent 98%, black) var(--r) 0`,
};

const couponUsedStyles = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(0, 0, 0, 0.4)',
  mask: `radial-gradient(var(--r) at calc(var(--r) - 5px) 50%, transparent 98%, black) calc(-1 * var(--r)) 0, radial-gradient(var(--r) at calc(100% - var(--r) + 5px) 50%, transparent 98%, black) var(--r) 0`,
  WebkitMask: `radial-gradient(var(--r) at calc(var(--r) - 5px) 50%, transparent 98%, black) calc(-1 * var(--r)) 0, radial-gradient(var(--r) at calc(100% - var(--r) + 5px) 50%, transparent 98%, black) var(--r) 0`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
};

const CouponCard = ({ data }) => {
  const navigate = useNavigate();
  const code = data.code;
  const status = data.status;

  return (
    <Box display={'flex'} gap={0.5} sx={couponStyles}>
      {/* LEFT */}
      <Box
        sx={{
          width: {
            xs: '45%',
            sm: '50%',
          },
          py: 1,
          px: 1.25,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          component={'img'}
          src={data?.reward_id?.image?.[0]}
          alt="Coupon"
          sx={{
            width: '100%',
            maxWidth: 150,
            position: 'relative',
            right: -5,
            scale: {
              xs: '1.125',
              sm: '1',
            },
          }}
        />
      </Box>
      {/* DASH DIVIDER */}
      <Box sx={{ my: 1, borderLeft: '2px dashed #AAA' }} />
      {/* RIGHT */}
      <Stack
        justifyContent={'center'}
        sx={{
          pt: 1.5,
          pb: 5,
          px: {
            xs: 1.25,
            sm: 4,
          },
          position: 'relative',
          width: '100%',
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            lineHeight: 1,
            fontSize: {
              xs: '1.75rem',
              sm: '2.25rem',
            },
            color: '#E1000C',
          }}
        >
          คูปองส่วนลด {data?.reward_id?.value || '0'}.-
        </Typography>
        <Typography
          sx={{
            fontWeight: 500,
            lineHeight: 1,
            mt: 0,
            fontSize: {
              xs: '1.25rem',
              sm: '1.75rem',
            },
            color: '#333',
          }}
        >
          {data?.reward_id?.name || '-'}
        </Typography>
        <Typography
          sx={{
            lineHeight: 1,
            mt: 0.5,
            fontSize: {
              xs: '1rem',
              sm: '1.5rem',
            },
          }}
        >
          หมดอายุ{' '}
          {data?.status.toLowerCase() === CouponStatus.ACTIVE
            ? dayjs('2027-01-31').format('DD/MM/YYYY')
            : '-'}
        </Typography>
        <AppButton
          size="small"
          variant="danger"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/my-coupon/${code}?tab=1`);
          }}
          sx={{
            mt: 1,
            mr: 0,
            ml: 'auto',
            py: 0.25,
            display: 'block',
            fontSize: {
              xs: '0.875rem',
              sm: '1.25rem',
            },
            fontWeight: 300,
            borderRadius: 30,
            boxShadow: 'none',
            position: 'absolute',
            bottom: 10,
            right: 10,
          }}
        >
          กดใช้คูปอง
        </AppButton>
      </Stack>
      {/* USED Filter */}
      {status.toLowerCase() === CouponStatus.WAITING && (
        <Box sx={couponUsedStyles} onClick={() => navigate(`/my-coupon/${code}?tab=2`)}>
          <Box
            component={'img'}
            src={CouponUsedImg}
            alt="Coupon Used"
            sx={{ width: '40%', maxWidth: '150px', position: 'relative', zIndex: 120 }}
          />
        </Box>
      )}
    </Box>
  );
};

export default CouponCard;
